
































import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({
  components: {
    CabeceraModal,
  },
})
export default class CabeceraModalSimVista extends Vue {
  @Prop({ default: false }) mostrarBtnVolver: Boolean;
  @Prop({ default: true }) mostrarBtnContinuar: Boolean;
  @Prop({ default: false }) mostrarBtnGuardar: Boolean;
  @Prop({ default: false }) permitirCont: Boolean;
  @Prop({ default: false }) permitirGuard: Boolean;

  cont() {
    this.$emit('continuar');
  }
  volv() {
    this.$emit('volver');
  }
  guard() {
    this.$emit('guardar');
  }
}
